import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { QRToggle } from 'src/app/models/qr-toggle.model';
import { TableHeader } from 'src/app/models/tableheader.model';
import { QRButton } from 'src/app/models/qr-button.model';
import { Constants } from 'src/app/models/constants';
import { environment } from '@base/environments/environment';

export interface Jurisdiction {
  altoDeductionPercentage?: number;
  id: number;
  iibb: number;
  name: string;
  previsionalCash?: number;
  puroDeductionPercentage?: number;
  stateId: string;
  teamDeductionPercentage: number;

    // Región DO
  deductionPercentage100?: number;
  deductionPercentage95?: number;
  deductionPercentage90?: number;
}
@Component({
  selector: 'app-jurisdiction',
  templateUrl: './jurisdiction.component.html',
  styleUrls: ['./jurisdiction.component.scss'],
})
export class JurisdictionComponent implements OnInit {
  @Input() jurisdictions: Jurisdiction[] = [];
  @Input() compensations: any[] = [];
  @Output() changeToggle: EventEmitter<any> = new EventEmitter<any>();
  @Output() onActionCompensation: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDeleteJurisdiction: EventEmitter<any> = new EventEmitter<any>();

  buttonEditJurisdiction: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.PENCIL_BLUE,
    iconOnly: true,
  };

  buttonEditCompensation: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.PENCIL_BLUE,
    iconOnly: true,
  };

  mainToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Jurisdicciones', 'Compensaciones'],
    optionSelected: 0,
  };

  kebabButtonConfig: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.KEBAB,
    iconOnly: true,
  };

  NODE = environment.node;
  NODE_AR = Constants.TENANT_ID_AR;
  NODE_GLOBAL = Constants.TENANT_ID_GLOBAL;
  NODE_DO = Constants.TENANT_ID_DO;

  tableHeaderOrderByJurisdictions: TableHeader[] = [
    {
      id: 'name',
      text: 'Nombre',
      percentageWidth: this.NODE != this.NODE_AR ? 28 : 25,
    },
    {
      id: 'iibb',
      text: 'IIBB',
      percentageWidth: this.NODE != this.NODE_AR ? 15 : 13,
    },
    {
      id: 'cashflow',
      text: 'Caja previsional',
      percentageWidth: 13,
    },
    {
      id: 'deduc-alto',
      text: 'Deduc. Alto',
      percentageWidth: this.NODE != this.NODE_AR ? 15 : 13,
    },
    {
      id: 'deduc-puro',
      text: 'Deduc. Puro',
      percentageWidth: this.NODE != this.NODE_AR ? 15 : 13,
    },
    {
      id: 'deduc-team',
      text: 'Deduc. Team',
      percentageWidth: this.NODE != this.NODE_AR ? 15 : 13,
    },
    {
      id: 'action',
      text: 'Acciones',
      percentageWidth: this.NODE != this.NODE_AR ? 12 : 10,
    },
  ];

  tableHeaderOrderByCompensations: TableHeader[] = [
    {
      id: 'variable',
      text: 'Compensación variable',
      percentageWidth: 30,
    },
    {
      id: 'billing',
      text: 'Facturación bruta',
      percentageWidth: 30,
    },
    {
      id: 'result',
      text: 'Resultado bruto',
      percentageWidth: 30,
    },
    {
      id: 'actions',
      text: 'Acciones',
      percentageWidth: 10,
    },
  ];

tableHeaderOrderByJurisdictionsDo: TableHeader[] = [
  { id: 'name', text: 'Nombre', percentageWidth: 28 },
  { id: 'iibb', text: 'IIBB', percentageWidth: 15 },
  { id: '100', text: '100%', percentageWidth: 15 },
  { id: '95', text: '95%', percentageWidth: 15 },
  { id: '90', text: '90%', percentageWidth: 15 },
  { id: 'deduc-team', text: 'Deduc. Team', percentageWidth: 15 },
  { id: 'action', text: 'Acciones', percentageWidth: 12 },
];


  ngOnInit() {
    this.validateRegion();
  }

  validateRegion() {
    if (this.NODE !== this.NODE_AR) {
      this.tableHeaderOrderByJurisdictions =
        this.tableHeaderOrderByJurisdictions.filter(
          (e: TableHeader) => e.id != 'cashflow'
        );
    }

    if (this.NODE === this.NODE_DO) {
      this.tableHeaderOrderByJurisdictions = this.tableHeaderOrderByJurisdictionsDo;
    }
  }

  onEditJurisdiction(row: any) {
    if (row?.id) location.href = 'configuration/edit-jurisdiction/' + row.id;
  }

  onEditCompensation(row: any) {
    return;
  }

  onChangeToggle($event: any) {
    this.mainToggle.optionSelected = $event;
    if (this.mainToggle.optionSelected == 1) {
      this.changeToggle.emit('compensation');
    } else {
      this.changeToggle.emit('jurisdiction');
    }
  }

  onActionButton(row: any, action: string) {
    if (row?.id) {
      const dto = {
        action: action,
        id: row.id,
      };
      this.onActionCompensation.emit(dto);
    }
  }

  onActionButtonJurisdiction(row: Jurisdiction, action: string) {
    if (action === 'edit') {
      this.onEditJurisdiction(row);
      return;
    }

    if (row?.id) {
      const DTO = {
        action: action,
        id: row.id,
      };
      this.onDeleteJurisdiction.emit(DTO);
    }
  }
}
